import React from 'react';
import { makeStyles } from '@mui/styles';
import mainLogo from '../resources/images/logo.png';

const useStyles = makeStyles(() => ({
  image: {
    alignSelf: 'center',
    maxWidth: '240px',
    maxHeight: '120px',
    width: 'auto',
    height: 'auto',
  },
}));

const LogoImage = ({ color }) => {
  const classes = useStyles();

  return (<img className={classes.image} src={mainLogo} style={{ color }} />);
};

export default LogoImage;
